var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb15"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.create}},[_vm._v(_vm._s(_vm.$t('create_stream')))])],1),_c('StreamItem',{ref:"stream"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }